import React from "react";

import Card from "@material-ui/core/Card";

import Typography from "@material-ui/core/Typography";
import phungo from "../images/phungo.png";
import Grid from "@material-ui/core/Grid";

import { useTheme } from "@material-ui/core/styles"; //for responsive
import useMediaQuery from "@material-ui/core/useMediaQuery";

import Container from "@material-ui/core/Container";

import TextTransition, { presets } from "react-text-transition";

import { MYCOLORS } from "../../mypallette";

import { darkThemeAtom } from "../../atoms";
import { useAtom } from "jotai";

import { useIntroStyles } from "./IntroStyles";

import Slide from "@material-ui/core/Slide";

//https://www.svgbackgrounds.com/
// import cardpaperLight from "./images/paperbg/Radiant-Gradient.svg" //Cornered-StairsLight.svg"; //
// import cardpaperDark from "./images/paperbg/Radiant-GradientDark2.svg";

//!https://stackoverflow.com/questions/48879517/passing-props-to-material-ui-style
//!https://stackoverflow.com/questions/48879517/passing-props-to-material-ui-style/51036613#51036613
//TODO REFACTOR need to add props to alternate background image based on darktheme

const TEXTS = ["Technical Project Manager", "dApp Developer"];

const Intro = () => {
  //use the darkThemeAtom
  const [darkTheme] = useAtom(darkThemeAtom);

  const classes = useIntroStyles();

  //access to theme
  const theme = useTheme();
  //matchSmall is true if window is sm or less(down)
  const matchSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const matchExtraSmall = useMediaQuery(theme.breakpoints.down("xs"));

  //speed for text animation.
  const [index, setIndex] = React.useState(0);
  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      2000 // every 2 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  return (
    <>
      {matchExtraSmall ? (
        <>
          <Card className={darkTheme ? classes.cardmainDark : classes.cardmainLight} elevation={4}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={0}
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  style={{ height: "320px" }}
                >
                  <Slide timeout={1900} direction='right' in={true} mountOnEnter unmountOnExit>
                    <img
                      src={phungo}
                      alt='phungoimage'
                      height='90%'
                      width='auto'
                      object-fit='scale-down'
                      style={
                        darkTheme
                          ? { backgroundColor: MYCOLORS.dphucircle, borderRadius: "50%" }
                          : { backgroundColor: MYCOLORS.lphucircle, borderRadius: "50%" }
                      }
                    />
                  </Slide>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={0} direction='column' alignItems='center' style={{ height: "200px" }}>
                  <Typography
                    align='center'
                    variant='h5'
                    className={darkTheme ? classes.titleDark : classes.titleLight}
                  >
                    Hi there, I'm
                  </Typography>
                  <Typography
                    align='center'
                    variant='h5'
                    className={darkTheme ? classes.titleDark : classes.titleLight}
                    style={{ fontSize: 50 }}
                  >
                    Phu Ngo
                  </Typography>
                  <Typography
                    align='center'
                    variant='h5'
                    className={darkTheme ? classes.titleDark : classes.titleLight}
                  >
                    <TextTransition direction='down' text={TEXTS[index % TEXTS.length]} springConfig={presets.gentle} />
                  </Typography>
                </Grid>
              </Grid>
              <div style={{ visibility: "hidden", margin: 0 }}>invis div cush</div>
            </Grid>
          </Card>
        </>
      ) : (
        <>
          {matchSmall ? (
            <>
              <Card className={darkTheme ? classes.cardmainDark : classes.cardmainLight} elevation={4}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={0}
                      direction='column'
                      alignItems='center'
                      justifyContent='center'
                      style={{ height: "600px" }}
                    >
                      <Slide timeout={1900} direction='right' in={true} mountOnEnter unmountOnExit>
                        <img
                          src={phungo}
                          alt='phungoimage'
                          height='90%'
                          width='auto'
                          object-fit='scale-down'
                          style={
                            darkTheme
                              ? { backgroundColor: MYCOLORS.dphucircle, borderRadius: "50%" }
                              : { backgroundColor: MYCOLORS.lphucircle, borderRadius: "50%" }
                          }
                        />
                      </Slide>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={0} direction='column' alignItems='center' style={{ height: "350px" }}>
                      <Typography
                        align='center'
                        variant='h3'
                        className={darkTheme ? classes.titleDark : classes.titleLight}
                      >
                        Hi there, I'm
                      </Typography>
                      <Typography
                        align='center'
                        variant='h3'
                        className={darkTheme ? classes.titleDark : classes.titleLight}
                        style={{ fontSize: 90 }}
                      >
                        Phu Ngo
                      </Typography>
                      <Typography
                        align='center'
                        variant='h3'
                        className={darkTheme ? classes.titleDark : classes.titleLight}
                      >
                        <TextTransition
                          direction='down'
                          text={TEXTS[index % TEXTS.length]}
                          springConfig={presets.gentle}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                  <div style={{ visibility: "hidden", margin: 0 }}>invis div cush</div>
                </Grid>
              </Card>
            </>
          ) : (
            <>
              <Card className={darkTheme ? classes.cardmainDark : classes.cardmainLight} elevation={4}>
                <Grid container spacing={0}>
                  <Grid item xs={6}>
                    <Grid
                      container
                      spacing={0}
                      direction='column'
                      alignItems='center'
                      justifyContent='center'
                      style={{ height: "600px" }}
                    >
                      <Slide timeout={1900} direction='right' in={true} mountOnEnter unmountOnExit>
                        <img
                          src={phungo}
                          alt='phungoimage'
                          width='90%'
                          height='auto'
                          object-fit='scale-down'
                          style={
                            darkTheme
                              ? { backgroundColor: MYCOLORS.dphucircle, borderRadius: "50%" }
                              : { backgroundColor: MYCOLORS.lphucircle, borderRadius: "50%" }
                          }
                        />
                      </Slide>
                    </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <Grid container spacing={0} direction='column' alignItems='center' style={{ height: "600px" }}>
                      <Container className={classes.container}>
                        <Typography></Typography>
                      </Container>

                      <Typography
                        align='center'
                        variant='h3'
                        className={darkTheme ? classes.titleDark : classes.titleLight}
                      >
                        Hi there, I'm
                      </Typography>
                      <Typography
                        align='center'
                        variant='h3'
                        className={darkTheme ? classes.titleDark : classes.titleLight}
                        style={{ fontSize: 90 }}
                      >
                        Phu Ngo
                      </Typography>
                      <Typography
                        align='center'
                        variant='h3'
                        className={darkTheme ? classes.titleDark : classes.titleLight}
                      >
                        <TextTransition
                          direction='down'
                          text={TEXTS[index % TEXTS.length]}
                          springConfig={presets.gentle}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Intro;
